<div class="modal-content">
    <div class="modal-header">
        <h3 class="modal-title font">{{ data.isMerma ? 'Añadir Merma' : 'Añadir Material' }}</h3>
        <button type="button" class="close" aria-label="Close" (click)="onCancel()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        
        <!-- MERMA MODE -->
        <div class="form-search py-3" *ngIf="data.isMerma">
            <div class="row-fields">
                 <div class="field field-100">
                    <label>Operación de Gestión (Merma)</label>
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <mat-select [(ngModel)]="selectedMermaOperation" placeholder="-- Seleccione Operación --">
                             <mat-option *ngFor="let op of mermaOperationsList" [value]="op">
                                {{op.codigo}} - {{op.descripcion}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- MATERIAL MODE -->
        <div class="form-search py-3" *ngIf="!data.isMerma">
            <div class="row-fields">
                <div class="field field-100">
                    <label>Material</label>
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <mat-select [(ngModel)]="selectedAgrupacion" placeholder="-- Seleccione Material --">
                            <mat-option *ngFor="let item of filteredAgrupacionList" [value]="item">
                                {{ item.descripcion }} 
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer actions">
        <div class="button-group">
            <button type="button" class="btn btn-outline-primary" (click)="onCancel()">Cancelar</button>
            <button type="button" class="btn btn-primary" 
                [disabled]="(!data.isMerma && !selectedAgrupacion) || (data.isMerma && !selectedMermaOperation)" 
                (click)="onAccept()">Aceptar</button>
        </div>
    </div>
</div>
